import React, { useState } from 'react';
import { MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';

function PaginationComponent({ totalPages, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(1);

  const handleClick = (page) => {
    setCurrentPage(page);
    onPageChange(page);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      onPageChange(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      onPageChange(currentPage - 1);
    }
  };

  return (
    <nav aria-label='Pagination' >
      <MDBPagination center size='lg' className='mb-0 mt-3'>
        <MDBPaginationItem disabled={currentPage === 1}>
          <MDBPaginationLink href='#' tabIndex={-1} aria-disabled={currentPage === 1} onClick={handlePreviousPage}>
            Previous
          </MDBPaginationLink>
        </MDBPaginationItem>
        {[...Array(totalPages).keys()].map((page) => (
          <MDBPaginationItem
            key={page}
            className={`page-item ${page + 1 === currentPage ? 'active' : ''}`}
            aria-current={page + 1 === currentPage ? 'page' : undefined}
          >
            <MDBPaginationLink
              className='page-link'
              onClick={() => handleClick(page + 1)}
            >
              {page + 1}
              {page + 1 === currentPage && <span className='visually-hidden'>(current)</span>}
            </MDBPaginationLink>
          </MDBPaginationItem>
        ))}
        <MDBPaginationItem disabled={currentPage === totalPages}>
          <MDBPaginationLink onClick={handleNextPage}>Next</MDBPaginationLink>
        </MDBPaginationItem>
      </MDBPagination>
    </nav>
  );
}

PaginationComponent.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default PaginationComponent;
